"use strict";

import { lcvManualPrizeWinsConstants } from "../_constants/lcvManualPrizeWins.constants";

export const lcvManualPrizeWinsGetRequest = (payload) => {
     return {
          type: lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_GET_REQUEST,
          payload,
     };
};

export const lcvManualPrizeWinsGetComplete = (payload) => {
     return {
          type: lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_GET_COMPLETE,
          payload,
     };
};

export const lcvManualPrizeWinsSetFulfilmentRequest = (payload) => {
     return {
          type: lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_REQUEST,
          payload,
     };
};

export const lcvManualPrizeWinsSetFulfilmentComplete = (payload) => {
     return {
          type: lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_COMPLETE,
          payload,
     };
};

export const lcvManualPrizeWinsClearActionResult = () => {
     return {
          type: lcvManualPrizeWinsConstants.LCV_MANUAL_PRIZE_WINS_CLEAR_ACTION_RESULT,
     };
};
